import { urpiweb } from './shared/helpers/constants';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GestureConfig, MatPaginatorIntl } from '@angular/material';
import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { InMemoryDataService } from './shared/inmemory-db/inmemory-db.service';
import { rootRouterConfig } from './app.routing';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GraphQLModule } from './graphql.module';
import { NgxUploaderModule } from 'ngx-uploader';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AuthenticationGuard, MsAdalAngular6Module } from 'microsoft-adal-angular6';
import { AuthGuard } from './shared/services/auth/auth.guard';
import { getDutchPaginatorIntl } from './shared/helpers/utils';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { urpiInterceptor } from './shared/interceptor/urpi-interceptor';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
}

export function loggerCallback(logLevel, message, piiEnabled) {
  console.log('client logging: ', logLevel + ' ' + message + ' ' + piiEnabled);
}

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    NgxDaterangepickerMd.forRoot(),
    NgxUploaderModule,
    HttpClientModule,
    PerfectScrollbarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    InMemoryWebApiModule.forRoot(InMemoryDataService, { passThruUnknownUrl: true }),
    RouterModule.forRoot(rootRouterConfig, { useHash: true }),
    MsAdalAngular6Module.forRoot({
      tenant: urpiweb.adal.tenant,
      clientId: urpiweb.adal.clientId,
      redirectUri: urpiweb.url.host,
      navigateToLoginRequestUrl: false,
      authority: 'https://login.microsoftonline.com/mibancoenlinea.onmicrosoft.com',
      endpoints:{
        'https://graph.microsoft.com': 'f9cadfec-ad1b-4441-8387-487d65dfd399',
        'https://graph.windows.net': 'f9cadfec-ad1b-4441-8387-487d65dfd399',
        'https://graph.microsoft.com/v1.0/me/': 'f9cadfec-ad1b-4441-8387-487d65dfd399',
        'https://graph.windows.net/me?api-version=1.6': 'f9cadfec-ad1b-4441-8387-487d65dfd399'
      }
    }),
    GraphQLModule,
    AngularFireModule.initializeApp(urpiweb.firebase),
    AngularFireDatabaseModule
  ],
  declarations: [AppComponent],
  providers: [
    { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: MatPaginatorIntl, useValue: getDutchPaginatorIntl() },
    { provide: HTTP_INTERCEPTORS, useClass: urpiInterceptor, multi: true },
    AuthenticationGuard,
    AuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
